export function getPlayerData() {
    let data = [
        { name: '杨力维', num: 3, position: '控球后卫' },
        { name: '李缘', num: 4, position: '控球后卫' },
        { name: '王思雨', num: 5, position: '得分后卫' },
        { name: '武桐桐', num: 6, position: '得分后卫' },
        { name: '金维娜', num: 7, position: '得分后卫' },
        { name: '李梦', num: 9, position: '小前锋' },
        { name: '张茹', num: 10, position: '小前锋' },
        { name: '黄思静', num: 11, position: '大前锋' },
        { name: '高颂', num: 12, position: '大前锋' },
        { name: '潘臻琦', num: 13, position: '大前锋' },
        { name: '李月汝', num: 14, position: '中锋' },
        { name: '韩旭', num: 15, position: '中锋' },
    ]
    //多音字转单音子
    const polyphonicCharacter = {
        曾: '増',
        沈: '伸',
        翟: '宅',
    }
    data = data.sort((a: any, b: any) => {
        const regExp = new RegExp('[\\u4E00-\\u9FFF]', 'g')
        const aIsCha = regExp.test(a.name)
        const bIsCha = regExp.test(b.name)
        if (aIsCha != bIsCha) {
            return aIsCha ? 1 : -1
        }
        const aName = a.name.split('')
        const bName = b.name.split('')

        for (let i = 0; i < aName.length; i++) {
            if (polyphonicCharacter[aName[i]]) {
                aName[i] = polyphonicCharacter[aName[i]]
            }
        }
        for (let i = 0; i < bName.length; i++) {
            if (polyphonicCharacter[bName[i]]) {
                bName[i] = polyphonicCharacter[bName[i]]
            }
        }
        return aName.join('').localeCompare(bName.join(''), 'zh')
    })
    const positionsData = {}
    data?.forEach((item: any) => {
        let pic = getRequire(item.name)
        let positionsName = item.position
        if (positionsName?.includes('后卫')) {
            positionsName = '后卫'
        } else if (positionsName?.includes('前锋')) {
            positionsName = '前锋'
        }

        if (positionsData[positionsName]) {
            positionsData[positionsName]?.push({
                pic: pic,
                ...item,
            })
        } else {
            positionsData[positionsName] = [
                {
                    pic: pic,
                    ...item,
                },
            ]
        }
    })
    const positions: any[] = []
    // 控球后卫——得分后卫——小前锋——大前锋——中锋
    const sortRule = ['控球后卫', '得分后卫', '小前锋', '大前锋', '后卫', '前锋', '中锋', '海外联赛']
    for (let key in positionsData) {
        const sort = sortRule.findIndex((item) => key == item)
        positions.push({
            sort: sort < 0 ? 10 : sort,
            title: key,
            data: positionsData[key],
        })
    }
    positions.sort(function (m, n) {
        if (m.sort < n.sort) return -1
        else if (m.sort > n.sort) return 1
        else return 0
    })
    const positionslist = [].concat(
        ...positions.map((item: any) => {
            return item.data
        }),
    )

    return { positions, data, positionslist }
}
export function getRequire(name: String) {
    const newName = name
    let pic = ''
    try {
        pic = require('@/assets/women-world-cup-personal-summary/女篮H5头像/' + newName + '.jpg')
    } catch (err) {
        try {
            pic = require('@/assets/women-world-cup-personal-summary/女篮H5头像/' + newName.split('-')[0] + '.jpg')
        } catch (err) {
            pic = require('@/assets/women-world-cup-personal-summary/女篮H5头像/空头像.png')
        }
    }
    return pic
}
